import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref } from "vue"

import { ElMenuItem, ElText, menuItemEmits } from 'element-plus'
import { Search, Edit, Plus, Minus, RefreshRight, Operation } from '@element-plus/icons-vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

interface MenuItem {
  index: string,
  label: string,
  icon?: any,
  router: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuView',
  setup(__props) {

const router = useRouter()
const menu = ref<MenuItem[]>([{
  index: '1',
  label: 'My Profiles',
  icon: Operation,
  router: 'profiles'
}, {
  index: '2',
  label: 'Profile Browser',
  icon: Operation,
  router: 'browser'
}])

const OnMenu = (m:MenuItem) => {
  router.push({ name: m.router })
}


return (_ctx: any,_cache: any) => {
  const _component_ElIcon = _resolveComponent("ElIcon")!
  const _component_ElMenu = _resolveComponent("ElMenu")!

  return (_openBlock(), _createBlock(_component_ElMenu, {
    collapse: false,
    class: "side-menu"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.value, (m) => {
        return (_openBlock(), _createBlock(_unref(ElMenuItem), {
          key: m.index,
          index: m.index,
          onClick: ($event: any) => (OnMenu(m))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ElIcon, null, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(m.icon)))
              ]),
              _: 2
            }, 1024),
            _createVNode(_unref(ElText), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(m.label), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["index", "onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})